module.exports = __webpack_public_path__ + "img/img1.8cd6b4c5.png";